import { doNotLogList } from 'iframe/ts/player/_shared/IFrameSharedData';
import { IFramePlayerAbstractClass } from 'iframe/ts/player/abstract/IFramePlayerAbstractClass';
import { TagAction } from 'tag/ts/tag/model/enums/TagAction';
export class TagNamespace extends IFramePlayerAbstractClass {
    constructor(iframePlayer) {
        super(iframePlayer, 'TagNamespace');
    }
    tagCallback = (event) => {
        if (this.utils.Type.isUndefined(event?.type))
            return;
        if (this.utils.Type.isString(event?.type) && !doNotLogList.includes(event?.type)) {
            this?.logger?.log('tagCallback:', event.type, event);
        }
        this.iframePlayer.postMessageHub.postMessage({
            tagEvent: {
                type: event?.type,
                uuid: event?.uuid,
                data: event?.data,
                msFromStart: event?.msFromStart,
                timeFromStart: event?.timeFromStart,
                targetName: event?.targetName
            }
        });
    };
    tagAction = (action) => {
        this?.logger?.log('tagAction:', action.action, action);
        this.iframePlayer.postMessageHub.postMessage({ tagAction: action });
        switch (action.action) {
            case TagAction.GET_SESSION_DATA: {
                switch (this.scripted) {
                    case true:
                        break;
                    case false:
                        const isClipBrowser = (this.runtimeVO.top.url.includes('player-services-clip-browser.tools.paramountplus.com')
                            ||
                                this.runtimeVO.top.url.includes('player-services-clip-browser-stage.tools.paramountplus.com'));
                        const host = this?.runtimeVO?.top?.parsed?.host;
                        const siteSessionData = {
                            sessionData: {
                                cpPre: (isClipBrowser === true ? 1 : 0),
                                cpSession: 0,
                                esb: '',
                                ftag: '',
                                ge: '0',
                                gr: '7',
                                host: host,
                                partner: (isClipBrowser === true ? undefined : window?.utag_data?.partner),
                                ppid: '12345',
                                ptype: 'video',
                                sb: '',
                                section: (isClipBrowser === true ? 'player-services-clip-browser' : 'web-article-page'),
                                session: (isClipBrowser === true ? undefined : window?.utag_data?.['cp.CBS_ADV_VAL']),
                                ssb: '',
                                sub: (isClipBrowser === true ? undefined : window?.utag_data?.userRegId),
                                subses: (isClipBrowser === true ? undefined : window?.utag_data?.['cp.CBS_ADV_SUBSES_VAL']),
                                tfcd: 0,
                                tsb: '',
                                vguid: (isClipBrowser === true ? undefined : window?.utag_data?.pageViewGuid),
                                vid: (isClipBrowser === true ? undefined : window?.utag_data?.videoId)
                            }
                        };
                        this?.logger?.log('tagAction:', action.action, 'siteSessionData:', siteSessionData);
                        switch (isClipBrowser) {
                            case true:
                                return new Promise(function (resolve, reject) {
                                    resolve(siteSessionData);
                                });
                            case false:
                                if (this.utils.Type.isEmpty(window?.utag_data)) {
                                    return undefined;
                                }
                                return new Promise(function (resolve, reject) {
                                    resolve(siteSessionData);
                                });
                        }
                }
                break;
            }
        }
    };
}
